import React, { memo } from 'react'
import { ContentPanelProps } from './types'

import * as styles from './styles.module.scss'

const ContentPanel = ({ children, height }: ContentPanelProps) => (
   <section
      className={styles.panel}
      style={{
         height,
      }}
   >
      {children}
   </section>
)

export default memo(ContentPanel)
